<template>
  <header>
    <div>
      <h1 class="navbar--header">
        <a class="navbar--header__brand" href="/#"><img
          class="navbar--header__brand__image"
          src="../assets/gvl-logo.svg"
          alt="labelrecherche.gvl.de"
        ></a>
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style lang="scss">
  header {
    margin: 0;
    padding: 0;
    position: fixed;
    text-align: left;
    top: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    border-bottom: 3px inset #ddd;

    .navbar--header {
      display: inline-block;
      left: 3px;
      margin: 0;
      padding: 0;
      position: relative;
      width: 35%;

      .navbar--header__brand__image {
        float: left;
        max-height: 100px;
        min-height: 20px;
        width: 100%;
      }
    }
  }
</style>
